export function registerServiceWorker() {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/firebase-messaging-sw.js').then((registration) => {
          console.log('[SW] Registered:', registration);
  
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (!installingWorker) return;
  
            installingWorker.onstatechange = () => {
                if (installingWorker.state === 'installed') {
                  if (navigator.serviceWorker.controller) {
                    console.log('[SW] New content is available, please refresh.');
                    // window.location.reload(); // bunu kaldır
                  }
                }
              };
          };
        }).catch((error) => {
          console.error('[SW] Registration failed:', error);
        });
      });
    }
  }